import { Injectable } from '@nestjs/common';
import * as fs from 'fs';
import { FileUploadIdReq } from './dto/file-upload-id.req';
import { FileUploadLogEntity } from './entities/file-upload-logs.entity';
import { FileUploadEntity } from './entities/file-upload.entity';
import { FileUploadLogRepo } from './repositories/file-upload-log.repo';
import { FileUploadRepo } from './repositories/file-upload.repo';
import { CommonResponseModel, GlobalResponseObject, ReferenceFeatures } from '@project-management-system/shared-models';
import { GenericTransactionManager } from '../../../typeorm-transactions';

@Injectable()
export class FileHandlingService {
  constructor(
    private filesRepo: FileUploadRepo,
    private fileUploadLogsRepo: FileUploadLogRepo
  ) { }

  async save(filesData: any[], createdUser: string, featuresRefName: ReferenceFeatures, featuresRefId: string, transactionalEntityManager?: GenericTransactionManager): Promise<FileUploadEntity[]> {

    try {
      const fileEntities: FileUploadEntity[] = [];
      filesData.forEach((file, index) => {
        const fileObj = new FileUploadEntity();
        const fileEntityKeys = Object.keys(file);
        Object.keys(fileObj).forEach((key) => {
          if (fileEntityKeys.includes(key)) {
            fileObj[key] = file[key];
          }
        });
        fileObj.fileName = file.filename
        fileObj.originalName = file.originalname
        fileObj.fileDescription = file.originalname
        fileObj.size = file.size
        fileObj.filePath = file.path
        fileObj.createdUser = createdUser;
        fileObj.featuresRefName = featuresRefName;
        fileObj.featuresRefNo = featuresRefId;
        fileObj.fileUploadId = file.fileUploadId;
        fileObj.type = file.mimetype;
        fileEntities.push(fileObj);
      });
      if (transactionalEntityManager) {
        const savedFileData = await transactionalEntityManager.getRepository(FileUploadEntity).save(fileEntities);
        return savedFileData;
      } else {
        // await this.filesRepo.delete({ featuresRefName: featuresRefName })
        const savedFileData = await this.filesRepo.save(fileEntities);
        return savedFileData;
      }

    } catch (error) {
      for (const file of filesData) {
        const filePath = file.filename;
        if (fs.existsSync(file.path)) {
          fs.unlinkSync(filePath);
        }
      }
    }
  }

  async getSavedFilesData(
    featuresRefId: string,
    featuresRefName: ReferenceFeatures,
    returnCommonResponse?: boolean
  ): Promise<any> {
    let where: {};
    if (featuresRefId) {
      where['featuresRefNo'] = featuresRefId;
    }
    if (featuresRefName) {
      where['featuresRefName'] = featuresRefName;
    }
    const filesData = await this.filesRepo.find({ where, order: { createdAt: 'DESC' } });
    const filesDestination = './upload_files';
    if (!fs.existsSync(filesDestination)) {
      fs.mkdirSync(filesDestination);
    }
    const filesResData = [];
    for (const fileData of filesData) {
      let file: any = {};
      file.name = fileData.originalName;
      file.uid = fileData.fileName;
      file.size = fileData.size;
      file.type = fileData.type;
      file.fileDescription = fileData.fileDescription;
      file.filePath = fileData.filePath;
      file.lastModified = fileData.lastModified;
      file.lastModifiedDate = fileData.lastModifiedDate;
      file.percent = fileData.percent;
      file.fileUploadId = fileData.fileUploadId;
      file.featuresRefId = featuresRefId;
      file.base64Url = '';
      filesResData.push(file);
    }
    if (returnCommonResponse) {
      return new CommonResponseModel(true, 123, '', filesResData);
    }
    return filesResData;
  }

  async deleteFilesData(featuresRefId: string, featuresRefName: ReferenceFeatures, transactionalEntityManager?: GenericTransactionManager) {
    if (transactionalEntityManager) {
      await transactionalEntityManager.getRepository(FileUploadEntity).delete({ featuresRefName, featuresRefNo: featuresRefId });
      return new GlobalResponseObject(true, 123, 'deleted successfully');
    } else {
      await this.filesRepo.delete({ featuresRefName, featuresRefNo: featuresRefId });
      return new GlobalResponseObject(true, 123, 'deleted successfully');
    }
  }

  async deleteSingleFile(req: FileUploadIdReq, transactionalEntityManager?: GenericTransactionManager, isReturn?: boolean): Promise<GlobalResponseObject> {
    const { fileUploadId, unitCode, createdUser } = req;
    const fileData = await this.filesRepo.findOne({ where: { fileUploadId } });
    console.log(fileData, "LLLLLLLLLLLLLL")
    if (fs.existsSync(fileData.filePath)) {
      fs.unlinkSync(fileData.filePath);
    }
    fileData.createdUser = createdUser;
    if (transactionalEntityManager) {
      await transactionalEntityManager.getRepository(FileUploadEntity).delete({ fileUploadId });
      await transactionalEntityManager.getRepository(FileUploadLogEntity).insert(fileData);
    } else {
      await this.filesRepo.delete({ fileUploadId });
      await this.fileUploadLogsRepo.insert(fileData);
    }
    if (!isReturn) {
      return new GlobalResponseObject(true, 123, 'deleted successfully');
    }

  }
}
